import { Composer } from "@/components/composer/Composer";

export function EmptyState() {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-[var(--reading-measure)] flex-col items-center justify-center gap-[var(--space-8)] px-[var(--space-4)] py-[var(--space-12)]">
      <h1 className="type-display text-balance text-center text-[var(--text-primary)]">
        What would you like to <span className="text-[var(--brand-hero)]">research</span>?
      </h1>

      {/* open-webui pattern: composer centered in the empty state. AppShell
          hides its bottom composer slot when messages.length===0 (T3.A) so
          this is the sole instance. */}
      <div className="w-full">
        <Composer />
      </div>
    </div>
  );
}
